import getConfig from 'next/config'
import axios from 'axios'
import { removeCookie, getCookiesValue } from 'helpers/cookie'

export const {
  publicRuntimeConfig: { baseURL },
} = getConfig()

const instance = axios.create({
  baseURL,
})

const requestMiddleware = (config) => {
  const accessToken = getCookiesValue('ac_token')
  const id = typeof window !== 'undefined' && window?.Echo?.socketId?.()

  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`)

    if (id) {
      config.headers.set('X-Socket-Id', id)
    }
  }

  return config
}

instance.interceptors.request.use(requestMiddleware)

instance.interceptors.response.use(
  function (response) {
    return response?.data
  },
  function (error) {
    if (error?.response?.status === 401) {
      removeCookie('ac_token')
    }
    return Promise.reject(error)
  }
)

export default instance
